import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-agent-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.css']
})
export class AgentDashboardComponent implements OnInit {
    public lineChartData: Array<any> = [
        { data: [7, 20, 12, 30, 22, 14, 11, 32, 44, 43, 55], label: 'Caricati' },
        { data: [3, 14, 25, 12, 1, 12, 5, 12, 8, 45, 40], label: 'In fornitura' },
        { data: [3, 14, 25, 12, 1, 12, 2, 11, 13, 32, 22], label: 'Ripensamenti' },
        { data: [3, 14, 25, 12, 1, 12, 4, 15, 24, 56, 2], label: 'Annullati' },
        { data: [1, 0, 0, 0, 0, 1, 2, 3, 1, 5, 1], label: 'Recessi' },
        { data: [1, 0, 0, 0, 0, 1, 3, 1, 4, 2, 10], label: 'Rinnovi' }
    ];
    public lineChartData3: Array<any> = [
        { data: [27, 30, 32, 40], label: 'Caricati' },
        { data: [33, 44, 45, 52], label: 'In fornitura' },
        { data: [23, 21, 25, 62], label: 'Ripensamenti' },
        { data: [35, 54, 31, 43], label: 'Annullati' },
        { data: [21, 32, 36, 56], label: 'Recessi' },
        { data: [25, 21, 23, 52], label: 'Rinnovi' }
    ];
    public lineChartData6: Array<any> = [
        { data: [56, 70, 82], label: 'Caricati' },
        { data: [73, 84, 85], label: 'In fornitura' },
        { data: [83, 74, 95], label: 'Ripensamenti' },
        { data: [88, 76, 89], label: 'Annullati' },
        { data: [21, 11, 15], label: 'Recessi' },
        { data: [51, 55, 56], label: 'Rinnovi' }
    ];
    public lineChartData12: Array<any> = [
        { data: [127, 120, 112, 130, 122, 114], label: 'Caricati' },
        { data: [123, 114, 125, 112, 111, 112], label: 'In fornitura' },
        { data: [31, 24, 25, 12, 131, 102], label: 'Ripensamenti' },
        { data: [23, 34, 26, 32, 112, 122], label: 'Annullati' },
        { data: [21, 11, 13, 0, 1, 11], label: 'Recessi' },
        { data: [14, 10, 77, 56, 34, 4], label: 'Rinnovi' }
    ];
    public lineChartLabels: Array<any> = [
        'Gennaio',
        'Febbraio',
        'Marzo',
        'Aprile',
        'Maggio',
        'Giugno',
        'Luglio',
        'Agosto',
        'Settembre',
        'Ottobre',
        'Novembre'
    ];
    public lineChartLabels3: Array<any> = [
        'Gennaio-Marzo',
        'Aprile-Giugno',
        'Luglio-Settembre',
        'Ottobre-Dicembre'
    ];
    public lineChartLabels6: Array<any> = [
        'Gennaio-Giugno 2017',
        'Luglio-Dicembre 2017',
        'Gennaio-Giugno 2018'
    ];
    public lineChartLabels12: Array<any> = ['2013', '2014', '2015', '2016', '2017', '2018'];
    public lineChartOptions: any = {
        responsive: true
    };
    public lineChartColors: Array<any> = [
        {
            // blue
            backgroundColor: 'rgba(255,255, 255, 0)',
            borderColor: '#02008C',
            pointBackgroundColor: '#02008C',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: '#02008C'
        },
        {
            // green
            backgroundColor: 'rgba(255,255, 255, 0)',
            borderColor: '#00D924',
            pointBackgroundColor: '#00D924',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: '#00D924'
        },
        {
            // cyan
            backgroundColor: 'rgba(255,255, 255, 0)',
            borderColor: '#00D6D9',
            pointBackgroundColor: '#00D6D9',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: '#00D6D9'
        },
        {
            // yellow
            backgroundColor: 'rgba(255,255, 255, 0)',
            borderColor: '#FFC300',
            pointBackgroundColor: '#FFC300',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: '#FFC300'
        },
        {
            // red
            backgroundColor: 'rgba(255,255, 255, 0)',
            borderColor: '#FA0000',
            pointBackgroundColor: '#FA0000',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: '#FA0000'
        },
        {
            // purple
            backgroundColor: 'rgba(255,255, 255, 0)',
            borderColor: '#AA00AD',
            pointBackgroundColor: '#AA00AD',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: '#AA00AD'
        }
    ];
    public lineChartLegend = true;
    public lineChartType = 'line';
    public barChartOptions: any = {
        scaleShowVerticalLines: false,
        responsive: true,
        plugins: [
            {
                beforeInit: chart => {
                    chart.data.labels.forEach((e, i, a) => {
                        if (/\n/.test(e)) {
                            a[i] = e.split(/\n/);
                        }
                    });
                }
            }
        ]
    };

    constructor() {}

    ngOnInit() {}
}



// WEBPACK FOOTER //
// ./src/app/pages/role-specific/agent/dashboard/dashboard.component.ts